// 管线总览
import req from './index'

//获取总览数据
export const getOverviewDataApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeOverview_Get', params)
}

//获取KML总览数据
export const getOverviewDataKMLApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeOverviewKml_Get', params)
}

//上传数据
export const submitOverviewDataApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeRoute_Import', params)
}

//上传KML数据
export const uploadKMLDataApi = (params) => {
  return req.file('api/admin.php?s=Admin.DockRoute.Pipe_Route_Import', params)
}

//上传KML数据
export const uploadKMLApi = (params) => {
  return req.file('api/admin.php?s=Admin.DockRoute.Pipe_Route_ImportTree', params)
}
//删除数据
export const delOverviewDataApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeRoute_Del', params)
}

//获取管网总览 数据
export const getOverviewTreeDataApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeOverviewTree_Get', params)
}

//删除管网总览 tree 数据
export const delOverviewListApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeRoute_Del', params)
}

//重命名 管网
export const setOverviewListApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeRoute_Set', params)
}

// 设置地图默认位置
export const setMapCenterPointApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.MapDefaultPosition_Set', params)
}

// 获取地图默认位置
export const getMapCenterPointApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.MapDefaultPosition_Get', params)
}

// 获取场站列表
export const getStationListApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.Station_List', params)
}

// 获取场站详情
export const getStationInfoApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.Station_Get', params)
}

// 删除场站列表
export const delStationListApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.Station_Del', params)
}

// 设置场站信息
export const setStationInfoApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.Station_Set', params)
}
